export default __webpack_public_path__ + "static/media/723.016099c8.png";